<template>
  <v-row>
    <v-col cols="12">
      <h6 class="mb-0 fieldset-title">لیست فرآیندهای منتخب</h6>
    </v-col>
    <v-col cols="12">
      <BaseTable
        :headers="fields"
        :items="items"
        tableClasses="item-table border"
        responsive
        hide-default-footer
        fixed-header
        ref="baseTable"
        height="200"
      >
      <template v-slot:[`item.productionProcessType`]="{ item }">
           <v-switch
                @click="changeStatus(item)"
                dense
                v-model="item.productionProcessType"
                :label="item.productionProcessType =='MainProcess'?'اصلی': 
                        item.productionProcessType =='SubProcess'?'فرعی':
                        item.productionProcessType ==null?'انتخاب کنید':''"
                false-value="SubProcess"
                true-value="MainProcess"        

        ></v-switch>

        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            icon
            title="حذف"
            color="error"
            @click="$emit('removeFromList', item)"
          >
            <v-icon> mdi-delete </v-icon>
          </v-btn>

        </template>
      </BaseTable>
    </v-col>
  </v-row>
</template>

<script>
import Helper from '@/core/helpers';

export default {
  name: 'MerchantCategoryComponent',
  props: {
    merchantCategoryTypes:{type:String},
    items: {
      type: Array,
    },
    fields: Array,
  },
  watch:{
    items(){
    
    }
  },
  methods:{
    changeStatus(item){
      this.$emit('changeProcessType', item, this.items)
    }
  }
};
</script>
<style scoped>
.fieldset-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 33px;
  color: #006298;
  text-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}
</style>
